"use client";

import type { Question } from "@studygenie/db";
import type { Dispatch, SetStateAction } from "react";
import { ResponsiveModal } from "@/components/responsive-modal";
import { useI18n } from "@/locales/client";
import { EditQuestionForm } from "./edit-question-form";

type Props = {
  question: {
    questions: Question;
    fileName: string | null;
    sourceType: string | null;
  };
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const EditQuestionModal = ({ question, isOpen, setIsOpen }: Props) => {
  const t = useI18n();

  return (
    <ResponsiveModal
      title={t("questionActions.edit.title")}
      description={t("questionActions.edit.description")}
      open={isOpen}
      onOpenChange={setIsOpen}
      form={<EditQuestionForm question={question} setIsOpen={setIsOpen} />}
    />
  );
};
